import { render, staticRenderFns } from "./SideBasket.vue?vue&type=template&id=357104f8&scoped=true&"
import script from "./SideBasket.vue?vue&type=script&lang=js&"
export * from "./SideBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357104f8",
  null
  
)

export default component.exports